import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const MeetingEventIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "MeetingEvent",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M26.29 29.71h-8a1.14 1.14 0 1 1 0-2.28h8c.63 0 1.14-.51 1.14-1.14V8c0-.63-.51-1.14-1.14-1.14H5.71c-.63 0-1.14.51-1.14 1.14v3.43H24a1.14 1.14 0 1 1 0 2.28H3.43c-.63 0-1.14-.51-1.14-1.14V8c0-1.89 1.54-3.43 3.43-3.43h20.57c1.89 0 3.43 1.54 3.43 3.43v18.29c0 1.89-1.54 3.43-3.43 3.43Z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M10.29 9.14c-.63 0-1.14-.51-1.14-1.14V3.43a1.14 1.14 0 1 1 2.28 0V8c0 .63-.51 1.14-1.14 1.14M21.71 9.14c-.63 0-1.14-.51-1.14-1.14V3.43a1.14 1.14 0 1 1 2.28 0V8c0 .63-.51 1.14-1.14 1.14M9.89 29.71c-.28 0-.57-.1-.79-.32l-5.56-5.3c-.8-.76-1.25-1.83-1.25-2.92 0-2.23 1.81-4.04 4.04-4.04h.37c1.06 0 2.1.43 2.86 1.18l.34.34.34-.34c.75-.75 1.79-1.18 2.86-1.18h.37c2.23 0 4.04 1.81 4.04 4.04 0 1.1-.46 2.17-1.25 2.92l-5.57 5.3c-.22.21-.5.32-.79.32Zm-4.77-7.27 4.77 4.55 4.78-4.55a1.752 1.752 0 0 0-1.21-3.02h-.37c-.46 0-.91.19-1.24.51l-1.15 1.15c-.21.21-.51.33-.81.33s-.59-.12-.81-.33l-1.15-1.15c-.33-.33-.78-.51-1.24-.51h-.37a1.748 1.748 0 0 0-1.2 3.02"
    })]
  }));
};
MeetingEventIcon.displayName = 'MeetingEventIcon';